import { useEffect, useState } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { AuthenticatedPath } from '@shared/constants/routes.constants';
import { useSignInControllerSignInUserMutation } from '@shared/services/apiService/apiService';
import { useAppDispatch } from '@shared/store';
import { actions } from '@shared/store/ducks';
import { SignInFormValues } from '../model/types';
import { getSignInErrorMessage } from '@shared/utils/apiError.utils';

export const useSignIn = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [errorMsg, setErrorMsg] = useState('');
  const [signInUser] = useSignInControllerSignInUserMutation();
  const { handleSubmit, setValue, control, ...formMethods } = useForm<SignInFormValues>({
    mode: 'onTouched',
    defaultValues: {
      login: '',
      password: '',
    },
  });

  const login = useWatch({ control, name: 'login' });
  const password = useWatch({ control, name: 'password' });

  useEffect(() => {
    setErrorMsg('');
  }, [login, password]);

  const onSubmit = handleSubmit(async (data) => {
    setErrorMsg('');

    const res: any = await signInUser({
      signInRequestDto: {
        login: data.login,
        password: data.password,
      },
    });

    if (res.error) {
      setErrorMsg(t(getSignInErrorMessage(res.error)));
    } else {
      setErrorMsg('');
      toast.dismiss();
      dispatch(actions.auth.signIn({ accessToken: res.data.accessToken }));

      navigate(AuthenticatedPath.CAMPAIGN);
    }
  });

  return {
    control,
    setValue,
    onSubmit,
    errorMsg,
    ...formMethods,
  };
};
